// extracted by mini-css-extract-plugin
module.exports = {"paper":"GroupCard_paper__sJpZM","actions":"GroupCard_actions__snL3j","loadingIndicator":"GroupCard_loadingIndicator__39GI0","table":"GroupCard_table__SEO6J"};